import React from "react";
// nodejs library that concatenates classes
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import styles from "assets/jss/xrs/components/parallaxStyle.js";
import { Box } from "@mui/material";

const useStyles = makeStyles()(() => styles);

export default function Parallax(props) {
  const { filter, className, children, style, image, small } = props;
  const { classes, cx } = useStyles();
  const parallaxClasses = cx({
    [classes.parallax]: true,
    [classes[filter + "Color"]]: filter !== undefined,
    [classes.small]: small,
    [className]: className !== undefined,
  });
  return (
    <Box
      component="div"
      className={parallaxClasses}
      sx={{
        ...style,
      }}
    >
      {children}
    </Box>
  );
}

Parallax.propTypes = {
  className: PropTypes.string,
  filter: PropTypes.oneOf([
    "primary",
    "primaryDark",
    "rose",
    "dark",
    "info",
    "success",
    "warning",
    "danger",
  ]),
  children: PropTypes.node,
  style: PropTypes.string,
  image: PropTypes.string,
  small: PropTypes.bool,
};
